import { render, staticRenderFns } from "./ItemModal.vue?vue&type=template&id=32ea6146&scoped=true&"
import script from "./ItemModal.vue?vue&type=script&lang=js&"
export * from "./ItemModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemModal.vue?vue&type=style&index=0&id=32ea6146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ea6146",
  null
  
)

export default component.exports